/** Türkçe sözlük · anaSayfa. Şekli bu dosya tanımlar; öteki diller ona bağlıdır. */
export const anaSayfa = {
  /** `screens/AnaSayfaScreen.tsx` */
  ekran: {
    baslik: "Ana sayfa",
    aciklama: "Kasanızın özeti; her kartın köşesindeki ? işareti kartın ne işe yaradığını anlatır.",
    okunamadi: "Kasanın özeti okunamadı",
  },

  getiri: {
    toplam: "Toplam getiri",
    sonYil: "Son 1 yıl",
    gunluk: "Günlük",
    hesaplanamadi: (m: string) => `Getiriler hesaplanamadı: ${m}`,
    hesaplaniyor: "Getiriler hesaplanıyor…",
    hesaplaniyorGun: (biten: number, toplam: number) => `Getiriler hesaplanıyor: ${biten} / ${toplam} gün`,
    etiket: (para: string) => `Getiri (${para})`,
    sebepBilinmiyor: "sebep bilinmiyor",
    dipnot: (para: string) => `${para} · geçmiş dahil getiri (satış, temettü/faiz dahil)`,
  },

  profil: {
    acikProfil: "Açık profil: ",
    profilSayisi: (n: number) => ` · ${n} profil`,
    hesapYok: "Bu profilde henüz hesap yok.",
    hesaplari: "Açık profilin hesapları",
    hareketSonEk: (_n: number) => " hareket",
    ayarlar: "Kilit ve profil ayarları",
  },

  hesap: {
    ozet: (hesap: number, hareket: number) => `${hesap} hesap · ${hareket} hareket`,
    sonHareket: (gun: string) => ` · son hareket ${gun}`,
    hareketler: "Hareketler",
    iceAktar: "İçe aktar",
    hesapAc: "Hesap aç",
    hareketGir: "Hareket gir",
    dosyadan: "Dosyadan içe aktar",
  },

  rapor: {
    ac: "Varlık dökümünü aç",
  },

  yedek: {
    hedef: "Hedef",
    sonYedek: "· son yedek",
    henuzYok: "henüz yok",
    obur: "Öbür cihazlar:",
    baskaCihazYok: "bu kasayı kullanan başka cihaz yok",
    alindi: (n: number, zaman: string) => `${n} değişiklik alındı · ${zaman}`,
    ayarlar: "Yedek ayarları",
    kur: "Yedeği kur",
  },

  fiyat: {
    izlenen: (n: number) => `Fiyatı kendiliğinden izlenen ${n} araç`,
    elle: (n: number) => ` · elle değerlenen ${n} varlık`,
    izleme: "İzleme",
  },

  sanal: {
    liste: "Sanal hesaplar",
    git: "Sanal hesaplar",
  },

  /** `components/tanitim/` — tanıtım sayfası ve kartlar. */
  tanitim: {
    satir1: "Portföy sizde, gizli.",
    satir2: "Fiyatlar kaynaktan.",
    satir3: "Rapor şeffaf.",
    giris:
      "Hisse, fon, borsa fonu ve döviz yatırımlarınızın kaydını tutun; maliyetinizi, kazancınızı ve temettülerinizi görün. Verileriniz yalnızca sizin cihazlarınızda ve kendi bulutunuzda durur.",
    kurulumMetni: "Yeni bir kasa kurun ya da başka bir cihazdaki kasanızı bulut yedeğinden açın.",
    kilitliMetni: "Bu cihazda kasanız var: parolanızla ya da 24 kelimelik kurtarma ifadenizle açın.",
    kurulumDugme: "Kasa kur ya da buluttan aç",
    kilitliDugme: "Kasayı aç",
  },

  kart: {
    ozeteDon: (baslik: string) => `${baslik}: özete dön`,
    neIseYarar: (baslik: string) => `${baslik}: bu kart ne işe yarar?`,
    defter: {
      baslik: "Gizlilik ve Profiller",
      tanitim:
        "Portföyünüz cihazınızdan çıkmaz: kasanız bu cihazda, parolanızla şifreli durur. Sunucu yalnızca fiyat ve kur arşivi tutar; kim olduğunuzu ve neye sahip olduğunuzu bilmez. Bir cihazda birden çok kasa (profil) tutabilirsiniz: her biri kendi parolasıyla, birbirini görmeden.",
    },
    baslangic: {
      baslik: "Hesaplar ve Hareketler",
      tanitim:
        "Farklı aracı kurum ve bankalardaki hesaplarınızı tek kasada toplayın; alım, satım, temettü ve nakit hareketlerinizi girin. Başka bir uygulamadaki kayıtlarınızı bir dosyayla tek seferde getirin.",
    },
    fiyatlar: {
      baslik: "Otomatik Fiyatlar",
      tanitim:
        "BIST hisseleri, TEFAS fonları, ABD borsa fonları ve döviz kurları kendiliğinden izlenir. Hangi fiyatın ne zamandan kaldığı her zaman görünür.",
    },
    raporlar: {
      baslik: "Rapor / Analiz",
      tanitim:
        "FIFO maliyet, gerçekleşmiş ve gerçekleşmemiş kazanç, temettü ve nakit akışı — istediğiniz para biriminde, istediğiniz tarih itibarıyla. Raporlar şeffaf: her değerin nereden geldiğini görebilirsiniz.",
    },
    yedek: {
      baslik: "Yedek ve Eşitleme",
      tanitim:
        "Kasanız şifreli olarak kendi Dropbox, Google Drive ya da OneDrive hesabınıza yedeklenir. Aynı kasayı kullanan cihazlarınız bu yedekle birbirini günceller.",
    },
    sanal: {
      baslik: "Sanal Hesaplar",
      tanitim:
        "Geriye dönük deneme: varlıkları, oranları, başlangıç tarihini ve düzenli alım tutarını seçin; hareketler geçmiş fiyatlarla kuraldan kurulur. Sanal hesaplar kasanın toplamlarına girmez.",
    },
  },

  /** `components/tanitim/gorseller.tsx` — SVG ve örnek rapor metinleri. */
  gorsel: {
    semaBaslik:
      "Kasanız cihazınızda açılır; kendi bulutunuza yalnızca şifreli kopyası gider; Parafon sunucusundan yalnızca fiyat ve kur gelir.",
    cihaz: "Cihazınız",
    cihazAlt: "kasa burada açılır",
    bulut: "Kendi bulutunuz",
    bulutAlt: "yalnızca şifreli kopya",
    sunucu: "Parafon sunucusu",
    sunucuAlt1: "sizi ve varlıklarınızı",
    sunucuAlt2: "bilmez",
    sifreliYedek: "şifreli yedek",
    fiyatKur: "fiyat ve kur",
    ornekAciklama: "Örnek rapor görünümü: rakamlar uydurmadır, gerçek bir portföye ait değildir.",
    raporBaslik: "Rapor · TRY",
    ornekVeri: "Örnek veri",
    ornek: {
      hisse: { ad: "BIST hissesi", deger: "48.250,00", degisim: "+12,4%" },
      fon: { ad: "TEFAS fonu", deger: "31.900,00", degisim: "+6,1%" },
      abd: { ad: "ABD borsa fonu", deger: "27.400,00", degisim: "−2,3%" },
    },
    toplam: "Toplam",
    toplamDeger: "107.550,00 ₺",
    nereden: "Bu değer nereden geldi?",
    neredenAyrinti: "125 adet × 386,00 ₺ · BIST kapanış fiyatı",
  },
};
